
import React from 'react';

import Efficiencypallet from './Efficiencypallet';
import Palletinjects from './Palletinjects';
import Palletvide from './Palletvide';
import Highsionstability from './Highsionstability';
import Plasticpallet from './Plasticpallet';
import Movableplates from './Movableplates';
import Choosingpallets from './Choosingpallets';

const Palletinjectonmol = () => {
    return (
        <div>
              <Efficiencypallet />
                    <Palletinjects />
                    < Palletvide />
                    <Highsionstability />
                    <Plasticpallet />
                    <Movableplates />
                    <Choosingpallets />
        </div>
    );
};

export default Palletinjectonmol;
